import React, { forwardRef } from "react"

interface IFlexItemProps extends React.HTMLAttributes<HTMLDivElement> {
    // Specifies the order of the flexible item
    // relative to the rest of the FlexItem inside the same container
    order?: React.CSSProperties["order"]
    // A number specifying how much the item will grow relative to the rest of the FlexItem
    grow?: React.CSSProperties["flexGrow"]
    // A number specifying how much the item will shrink relative to the rest of the FlexItem
    shrink?: React.CSSProperties["flexShrink"]
    // The length of the item
    basis?: React.CSSProperties["flexBasis"]
    // A shorthand property for the flex-grow, flex-shrink, and the flex-basis properties
    flex?: React.CSSProperties["flex"]
    // Specifies the alignment for the selected item inside the Flex container
    alignSelf?: React.CSSProperties["alignSelf"]
}

const FlexItem = forwardRef<HTMLDivElement, React.PropsWithChildren<IFlexItemProps>>(({
    order,
    grow,
    shrink,
    basis,
    flex,
    alignSelf,
    children,
    ...others
}, ref) => {
    const style: React.CSSProperties = {
        order,
        flexGrow: grow,
        flexShrink: shrink,
        flexBasis: basis,
        alignSelf,
    }

    if (typeof flex !== "undefined") {
        style.flex = flex
    }

    return (
        <div style={style}
            {...others}
            ref={ref}>
            {children}
        </div>
    )
})

export default FlexItem
